import { Faq } from '@/api/gql/graphql';
import { create } from 'zustand';

interface FaqByCategory {
  name: string;
  _id: string;
}

type FaqStore = {
  selectedFaq: FaqByCategory | null;
  setSelectedFaq: (faq: FaqByCategory | null) => void;
  isOpenModal: boolean;
  setIsOpenModal: (isOpenModal: boolean) => void;
  isOpenForm: boolean;
  setIsOpenForm: (isOpenForm: boolean) => void;
  isEditMode: boolean;
  setIsEditMode: (isEditMode: boolean) => void;
  faq: Faq | null;
  setFaq: (faq: Faq | null) => void;
  statusFilter: string[];
  setStatusFilter: (statusFilter: string[]) => void;
};

export const useFaqStore = create<FaqStore>((set) => ({
  selectedFaq: null,
  setSelectedFaq: (faq) => set({ selectedFaq: faq }),
  isOpenModal: false,
  setIsOpenModal: (isOpenModal) => set({ isOpenModal }),
  isOpenForm: false,
  setIsOpenForm: (isOpenForm) => set({ isOpenForm }),
  isEditMode: false,
  setIsEditMode: (isEditMode) => set({ isEditMode }),
  faq: null,
  setFaq: (faq) => set({ faq }),
  statusFilter: [],
  setStatusFilter: (statusFilter) => set({ statusFilter }),
}));
